import { render } from "./EditAddressModal.vue?vue&type=template&id=f41b8bf0&scoped=true"
import script from "./EditAddressModal.vue?vue&type=script&lang=js"
export * from "./EditAddressModal.vue?vue&type=script&lang=js"

import "./EditAddressModal.vue?vue&type=style&index=0&id=f41b8bf0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41b8bf0"]])

export default __exports__